import makeStyles from '@mui/styles/makeStyles';
import { isDark } from 'global/styles';
import { alpha } from '@mui/material/styles';

const useStyles = makeStyles((theme) => ({
  sidebarWidth: {
    width: '300px',
    height: 'calc(100vh - 64px)',
    [theme.breakpoints.down('lg')]: {
      width: '0px',
    },
  },
  fullWidth: {
    width: '100%',
    height: (p) => (p.isMobile ? undefined : 'calc(100vh - 64px)'),
  },
  list: {
    overflowY: 'scroll',
    position: 'fixed',
    zIndex: 100,
    transition: (p) => (p.isMobile ? undefined : theme.transitions.create('width', { duration: theme.transitions.duration.complex })),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  editionTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(8),
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(1),
    },
  },
  title: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  active: {
    backgroundColor: theme.palette.action.hover,
  },
  noPad: {
    padding: 0,
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  avatar: {
    backgroundColor: theme.palette.text.secondary,
  },
  avatarSelect: {
    backgroundColor: 'transparent',
  },
  rowIcon: {
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
  },
  rowIconActive: {
    color: isDark(theme) ? theme.colors.white : theme.colors.black,
  },
  rowIconInactive: {
    color: theme.palette.grey[500],
  },
  closeIcon: {
    color: isDark(theme) ? theme.colors.white : theme.palette.primary.main,
  },
  documentItemUpdated: {
    backgroundColor: theme.palette.warning.light,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  documentItemNew: {
    backgroundColor: theme.palette.success.light,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    },
  },
  showChangesRow: {
    padding: theme.spacing(2),
    marginTop: -theme.spacing(2),
  },
  dangerBg: {
    backgroundColor: alpha(theme.colors.danger, 0.15),
  },
}));

export default useStyles;
